// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"0f217065","375":"933ce01e","403":"0f217065","427":"933ce01e","737":"4528d905"}[chunkId] + ".chunk.css";
};